export const iconFontAwesomeArrowsCaretDown = (
	<i className="fa-solid fa-caret-down"></i>
);
